module.exports = __webpack_public_path__ + "static/media/Triangle.c48bae5c.png";